import Cookies from 'js-cookie';

class SessionService {
  // Cookies
  // ===============================================
  getCookie(cname) {
    return Cookies.get(cname);
  }

  // static get USER () {
  //     return '_user'
  // }

  // Local Storage
  // ===============================================
  getLocalData(sname) {
    const data = localStorage.getItem(sname);
    return data ? JSON.parse(data) : null;
  }

  removeCookie(name) {
    Cookies.remove(name, {
      expires: 0,
      domain: `${window.location.hostname}`,
    });
  }

  removeSession(name) {
    localStorage.removeItem(name);
  }

  setCookie(name, value, expires = 21600) {
    expires = new Date(new Date().getTime() + (expires * 1000));

    Cookies.set(name, value, {
      expires,
      domain: `${window.location.hostname}`,
    });
  }

  clearAuthSession() {
    this.removeSession('_refresh_token');
    this.removeSession('_token');
    this.removeSession('_user');
    this.removeCookie('_id');
  }

  setLocalData(name, value) {
    localStorage.setItem(name, JSON.stringify(value));
  }
}

export default new SessionService();
